/**
 * Report form tab (report body).
 */
import * as React from 'react';
import { SYNTHESIS_MEETING_TYPE_LABEL } from '@/components/reports/report-configs';
import { TutoringReportForm } from '@/components/reports/remote/report-form-builder/TutoringReportForm';
import { MeetingSynthesisForm } from '@/components/reports/remote/report-form-builder/MeetingSynthesisForm';
import {
  isSynthesisReportSchema,
  isTutoringReportSchema,
  reportReadOnlyMessage,
} from '@/components/reports/remote/report-form-utils';

/** Props for {@link ReportTab}. */
export interface ReportTabProps {
  schemaId: string;
  status: string;
  fields: Record<string, unknown>;
  onChange: (patch: Record<string, unknown>) => void;
  isReadOnly: boolean;
}

/** Remote report body tab (tutoring or synthesis schema). */
export const ReportTab: React.FC<Readonly<ReportTabProps>> = ({
  schemaId,
  status,
  fields,
  onChange,
  isReadOnly,
}) => (
  <>
    {isReadOnly && (
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-amber-800 mb-4">
        {reportReadOnlyMessage(status)}
      </div>
    )}

    {isTutoringReportSchema(schemaId) && (
      <TutoringReportForm fields={fields} onChange={onChange} isReadOnly={isReadOnly} />
    )}

    {isSynthesisReportSchema(schemaId) && (
      <MeetingSynthesisForm
        fields={fields}
        onChange={onChange}
        isReadOnly={isReadOnly}
        meetingLabel={SYNTHESIS_MEETING_TYPE_LABEL[schemaId] ?? ''}
      />
    )}
  </>
);
